import { instance, errorService } from '@/services/api'
import { showNotification } from '@/services/calculate'
import _ from 'lodash'

export default {
  name: 'SaveGroupingBank',
  props: {
    visible: Boolean,
    type: String,
    bankName: String,
    bankId: Number,
    screenId: Number,
    templateId: String,
    apiURL: String,
  },
  data() {
    return {
      form: {
        label: this.bankName,
        interior_Grouping_Id: this.bankId,
        template_Id: this.templateId,
        screeen_Id: this.screenId,
      },
      rules: {
        label: [
          {
            required: true,
            message: 'Please enter bank name',
            trigger: 'blur',
          },
        ],
      },
      loading: false,
      closable: true,
    }
  },
  created() {
    this.loading = false
  },
  methods: {
    handleOk() {
      this.loading = true
      this.closable = false
      let data = {
        label: this.form.label,
      }
      const url = this.apiURL
      if (this.type === 'Tenant Bank') {
        data = {
          tenantBank: this.form.label,
        }
      }
      instance
        .post(url, data)
        .then(response => {
          this.closable = true
          if (response.data.message) {
            switch (response.data.message) {
              case 'Interior grouping already exists.':
              case 'Interior grouping updated successfully':
              case 'Tenant bank already exists.':
              case 'Interior grouping bank already exists. Please enter different name.':
                showNotification('warning', this.type, response.data.message)
                this.loading = false
                break
              default:
                showNotification('success', this.type, _.get(response.data, 'message', null))
                this.$root.$emit('reloadBanks')
                this.$emit('closeBank', false)
            }
          } else {
            this.$root.$emit('reloadBanks')
            this.$emit('closeBank', false)
          }
        })
        .catch(error => {
          this.closable = true
          this.loading = false
          errorService(error)
        })
    },

    handleCancel() {
      this.$emit('closeBank', false)
    },
  },
}
